<template>
	<div class="g-page flex-column">
		<div class="g-head flex-center-cross">
			<img class="logo" :src="systemConfig.seller_login_logo">
		</div>
		<div class="g-body flex-grow flex-center">
			<div class="g-main">
				<div class="login">
					<h1 class="title">密码登录<span>Password login</span></h1>
					<c-form ref="form" class="form">
						<div class="item flex-column">
							<label class="flex-center-cross"><i class="tf tf-company tf-fw"></i>商家名称</label>
							<c-input class="input" type="text" name="company_name" placeholder="请输入商家名称" :clear="false" @enter="login"></c-input>
						</div>
						<div class="item flex-column">
							<label class="flex-center-cross"><i class="tf tf-username tf-fw"></i>用户名</label>
							<c-input type="text" name="user_name" placeholder="请输入用户名" :clear="false" @enter="login"></c-input>
						</div>
						<div class="item flex-column">
							<label class="flex-center-cross"><i class="tf tf-password tf-fw"></i>密码</label>
							<c-input type="password" name="user_pwd" placeholder="请输入密码" :clear="false" @enter="login"></c-input>
						</div>
					</c-form>
					<c-button class="button" color="main" @click="login">登录</c-button>
				</div>
			</div>
			<div class="g-foot">{{systemConfig.seller_copyright}}</div>
			<p style="display: none;">©2023 杭州云创数智科技有限公司 提供技术支持</p>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		computed: {
			...mapState(['systemConfig']),
		},
		
		methods: {
			login() {
				this.$refs.form.submit({
					url: '/stationed/user/login',
					rule: {
						company_name: [{
							type: 'empty',
							message: '请输入商家名称'
						}],
						user_name: [{
							type: 'empty',
							message: '请输入用户名'
						}],
						user_pwd: [{
							type: 'empty',
							message: '请输入密码'
						}]
					},
					dataFormatter: data => {
						data.stationed_type = 2;
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						return data;
					},
					success: (data, res) => {
						this.$store.commit('setSession', res.user_info.session);
						this.$store.commit('setUserInfo', res.user_info);
						this.$store.commit('setNav', res.user_menu_list || []);
						this.$store.commit('setAuth', Array.from(res.user_menu_key_list, item => item.menu_unique_key));
						this.navigateTo('/');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-head {
			position: fixed;
			left: 0;
			right: 0;
			top: 0;
			height: 80px;
			padding: 0 60px;
			background: rgba(255,255,255,.6);
			
			.logo {
				height: 60px;
			}
		}
		
		.g-body {
			background-image: url('~@/assets/image/saas/login_bg.png');
			background-size: cover;
			
			.g-main {
				.login {
					box-sizing: border-box;
					width: 400px;
					height: 420px;
					border-radius: 8px;
					padding: 0 40px;
					overflow: hidden;
					background: #fff;
					
					.title {
						height: 86px;
						line-height: 100px;
						font-size: 20px;
						
						span {
							margin-left: 10px;
							font-size: 12px;
							font-weight: normal;
							color: #bbb;
						}
					}
					
					.form {
						row-gap: 0;
						padding: 0;
						
						.item {
							width: 100%;
							margin-bottom: 10px;
							
							label {
								height: 34px;
								
								.tf {
									margin-right: 8px;
									font-size: 14px;
								}
							}
							
							.input {
								height: 40px;
								border-radius: 4px;
							}
						}
					}
					
					.button {
						width: 100%;
						height: 50px !important;
						margin-top: 10px;
						font-size: 18px !important;
					}
				}
			}
		}
		
		.g-foot {
			position: fixed;
			left: 0;
			bottom: 0;
			right: 0;
			line-height: 56px;
			font-size: 12px;
			text-align: center;
			color: #999;
		}
	}
</style>
